<template>
	<div class="wrapper__menubar" :class="{ sticky: position == 'sticky' }">
		<editor-menu-bar :editor="editor" v-slot="{ commands, isActive, getMarkAttrs }">
			<div class="menubar">
				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.heading({ level: 2 }) }"
					@click="commands.heading({ level: 2, id: generateUUID() })"
					title="Title h2: Shift-Ctrl-2"
				>
					<i class="fa-solid fa-h2"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.heading({ level: 3 }) }"
					@click="commands.heading({ level: 3, id: generateUUID() })"
					title="Title h3: Shift-Ctrl-3"
				>
					<i class="fa-solid fa-h3"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.paragraph() }"
					@click="commands.paragraph"
					title="Paragraph"
				>
					<i class="fa-solid fa-paragraph"></i>	
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.bold() }"
					@click="commands.bold"
					title="Bold: Ctrl-B"
				>
					<i class="fa-solid fa-bold"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.italic() }"
					@click="commands.italic"
					title="Italic: Ctrl-I"
				>
					<i class="fa-solid fa-italic"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.strike() }"
					@click="commands.strike"
					title="Strikethrough"
				>
					<i class="fa-solid fa-strikethrough"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.underline() }"
					@click="commands.underline"
					title="Underline: Ctrl-U"
				>
					<i class="fa-solid fa-underline"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.code() }"
					@click="commands.code"
					title="Inline code"
				>
					<i class="fa-solid fa-code"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.bullet_list() }"
					@click="commands.bullet_list"
					title="Bullet list: Shift-Ctrl-8"
				>
					<i class="fa-solid fa-list"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.ordered_list() }"
					@click="commands.ordered_list"
					title="Oredered list: Shift-Ctrl-9"
				>
					<i class="fa-solid fa-list-ol"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.blockquote() }"
					@click="commands.blockquote"
					title="Block Quote: Ctrl-Shift-."
				>
					<i class="fa-solid fa-quote-right"></i>
				</button>

				<button
					class="menubar__button"
					:class="{ 'is-active': isActive.code_block() }"
					@click="commands.code_block"
					title="Code block: Shift-Ctrl-\"
				>
					<i class="fa-solid fa-file-code"></i>
				</button>

				<button
					class="menubar__button"
					@click="commands.horizontal_rule"
					title="Horizontal divider"
				>
					<i class="fa-solid fa-horizontal-rule"></i>
				</button>

				<button
					class="menubar__button"
					@click="openUrlModal(commands.link, 'href', getMarkAttrs('link'))"
					title="Insert Link"
				>
					<i class="fa-solid fa-link"></i>
				</button>

				<button
					class="menubar__button"
					@click="openUrlModal(commands.image, 'src', getMarkAttrs('image'))"
					title="Insert Image"
				>
					<i class="fa-regular fa-image"></i>
				</button>

				<button
					class="menubar__button"
					@click="openUrlModal(commands.iframe, 'src', getMarkAttrs('iframe'))"
					title="Insert Video"
				>
					<i class="fa-solid fa-video"></i>
				</button>

				<button
					class="menubar__button"
					@click="commands.undo"
					title="Undo: Ctrl-Z"
				>
					<i class="fa-solid fa-rotate-left"></i>
				</button>

				<button
					class="menubar__button"
					@click="commands.redo"
					title="Redo: Ctrl-Y"
				>
					<i class="fa-solid fa-rotate-right"></i>
				</button>

				<button
					class="menubar__button"
					title="Add Table"
					@click="
						commands.createTable({
							rowsCount: 3,
							colsCount: 3,
							withHeaderRow: false,
						})
					"
				>
					<i class="fa-solid fa-table-cells"></i>
				</button>

				<span class="table-btns" v-if="isActive.table()">
					<button
						class="menubar__button"
						title="Delete Table"
						@click="commands.deleteTable"
					>
						<Icon name="table-delete" width="16px" height="16px" />
					</button>
					<button
						class="menubar__button"
						title="Add Column Before"
						@click="commands.addColumnBefore"
					>
						<Icon name="table-addcb" width="16px" height="16px" />
					</button>
					<button
						class="menubar__button"
						title="Add Column After"
						@click="commands.addColumnAfter"
					>
						<Icon name="table-addca" width="16px" height="16px" />
					</button>
					<button
						class="menubar__button"
						title="Delete Column"
						@click="commands.deleteColumn"
					>
						<Icon name="table-delc" width="16px" height="16px" />
					</button>
					<button
						class="menubar__button"
						title="Add Row Before"
						@click="commands.addRowBefore"
					>
						<Icon name="table-addrb" width="16px" height="16px" />
					</button>
					<button
						class="menubar__button"
						title="Add Row After"
						@click="commands.addRowAfter"
					>
						<Icon name="table-addra" width="16px" height="16px" />
					</button>
					<button
						class="menubar__button"
						@click="commands.deleteRow"
						title="Delete Row"
					>
						<Icon name="table-delr" width="16px" height="16px" />
					</button>
					<button
						class="menubar__button"
						title="Merge Cells"
						@click="commands.toggleCellMerge"
					>
						<Icon name="table-merge" width="16px" height="16px" />
					</button>
					<button
						class="menubar__button"
						title="Header Cell"
						@click="commands.toggleHeaderCell"
					>
						HC
					</button>
				</span>
			</div>
		</editor-menu-bar>
		<InputDialog
			:label="'URL'"
			:message="'Enter URL here'"
			ref="inputDialog"
			@valueinserted="handleInputDialogValue"
		/>
	</div>
</template>

<script>
import Icon from "./Icon";
import InputDialog from "../../shared/InputDialog";
import { EditorMenuBar } from "tiptap";
import { v4 as uuidv4 } from "uuid";

export default {
	name: "EditorMenu",
	components: {
		EditorMenuBar,
		Icon,
		InputDialog,
	},
	props: ["editor", "position"],
	data: function () {
		return {
			selectedCommand: null,
			urlType: null,
		};
	},
	methods: {
		generateUUID: function () {
			return uuidv4();
		},
		openUrlModal: function (command, type, attrs) {
			let url = attrs ? attrs.href || attrs.src : '';
			this.selectedCommand = command;
			this.urlType = type;
			this.$refs.inputDialog.show(url);
		},
		handleInputDialogValue: function (url) {
			if (url !== null) {
				if (this.urlType === "src") {
					this.selectedCommand({ src: url });
					this.selectedCommand = null;
					this.urlType = null;
					this.$refs.inputDialog.hide();
				}
				if (this.urlType === "href") {
					this.selectedCommand({ href: url });
					this.selectedCommand = null;
					this.urlType = null;
					this.$refs.inputDialog.hide();
				}
			}
		},
	},
};
</script>

<style>

.menubar {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 1rem;
	background-color: #fff;
}

.menubar__button {
	background-color: var(--clr-accent-primary-shade-1);
	border: none;
	border-radius: 0.2em;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	margin-right: 0.5rem;
	color: var(--clr-accent-primary);
}

.menubar__button:hover {
	background-color: var(--clr-accent-primary-shade-3);
}

.menubar__button:active,
.menubar__button:focus {
	outline: none;
}

.is-active {
	background-color: var(--clr-accent-primary);
	color: #fff;
}

.wrapper__menubar {
	display: flex;
}

.sticky {
	position: sticky;
	top: 0px;
	z-index: 50;
}

.sticky .menubar {
	border: 1px solid var(--clr-neutral-shade-3);
	border-radius: 0.2em;
	padding: 1em 1.2em;
	margin: 0;
	box-shadow: 0 0 0.5em 0 rgb(0, 0, 0, 0.1);
}

.table-btns {
	display: flex;
}

</style>